import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { urlparams } from "../../config/bootstrap";
import { onClickNavLinkMantra } from "../../utils/helper";

const Mantra18 = ({ data }) => {
  const [TickArr, setTettickArr] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("doneMantraArray")) {
      let doneMantraArray = JSON.parse(localStorage.getItem("doneMantraArray"));
      setTettickArr(doneMantraArray);
    }
  }, []);

  return (
    <section className="col-12">
      <div className="m18_card_wrp">
        <h2 className="m18_txt">Mantra 18</h2>
        <div className="d-flex align-items-center justify-content-center">
          <img src="/assets/img/mantra18_f.gif" className="m18_card_img" />
        </div>
        <div className="ico_edit_certif">
          {data.link && data.link == "false" ? (
            <img src="/assets/img/edit.png" />
          ) : (
              <NavLink
                to={"/module/" + "m18" + "/" + urlparams + "&view="}
                onClick={() => onClickNavLinkMantra("/module/m18", data)}
              >
                <img src="/assets/img/edit.png" id={"navigate_m18"} onClick={() => { localStorage.setItem('navigate', 'm18') }} />
              </NavLink>
            )}
          {TickArr.includes("m18") && <img src="/assets/img/tick.png" className="tick_img" />}
        </div>
      </div>
    </section>
  );
};
export default Mantra18;
